<template>
  <centered-layout>
    <div class="auth-page auth-page--login">
      <site-logo show-secondary-shn-logo />
      <site-masthead />
      <h1 class="auth-page__heading">Have an account? Log in.</h1>

      <login-with-email class="auth-page__form" />

      <or-divider />
      <social-login />
      <div
        v-if="siteHasFeature('Accounts')"
        class="auth-page__navigation"
      >
        <p>Don't have an account?</p>
        <router-link
          :to="{
            path: '/register',
            query: $route.query,
          }"
        >Create one now.
        </router-link>
      </div>
      <disclaimer-component-with-recaptcha />
    </div>
  </centered-layout>
</template>

<script>
import SiteLogo from '@/components/Global/SiteLogo.vue';
import SiteMasthead from '@/components/Footer/SiteMasthead.vue';
import LoginWithEmail from '@/components/Auth/LoginWithEmail.vue';
import OrDivider from '@/components/Auth/OrDivider.vue';
import SocialLogin from '@/components/Social/SocialLogin.vue';
import DisclaimerComponentWithRecaptcha from '@/components/Auth/DisclaimerComponentWithRecaptcha.vue';
import { mapGetters } from 'vuex';
import authRedirectMixin from '@/mixins/auth-redirect-mixin';

export default {
  name: 'LoginPage',
  components: {
    LoginWithEmail,
    SiteLogo,
    SiteMasthead,
    OrDivider,
    SocialLogin,
    DisclaimerComponentWithRecaptcha,
  },
  mixins: [authRedirectMixin],
  metaInfo: {
    title: 'Login',
    meta: [
      {
        name: 'robots',
        vmid: 'robots',
        content: 'noindex',
      },
    ],
  },
  computed: {
    ...mapGetters([
      'siteHasFeature',
    ]),
  },
  mounted() {
    this.$emit('loaded');
    this.attemptRedirect();

    if (this.redirectToModeration) {
      this.$store.dispatch('addToastNotification', {
        toastType: 'error',
        description: 'You must be logged in to access moderation',
      });
    }
  },
  beforeDestroy() {
    this.$store.dispatch('clearLogInForm');
  },
  methods: {
    attemptRedirect() {
      if (!this.userIsLoggedIn) { return; }
      this.handleLoginRedirect();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_auth-page';
</style>
